import { REQUEST_CUSTOM_TAGS, TAG_BUTTON_CLICKED, TAG_BUTTON_CLICKED_RESET } from "../types"

export const requestCustomTags = () => ({
	type: REQUEST_CUSTOM_TAGS,
})

export const tagButtonClicked = () => ({
	type: TAG_BUTTON_CLICKED,
})

export const tagButtonClickedReset = () => ({
	type: TAG_BUTTON_CLICKED_RESET,
})
